export const BACKEND_URL = process.env['BACKEND_URL'];
export const ADMIN_URL = process.env['ADMIN_URL'];
export const FRONTEND_URL = process.env['FRONTEND_URL'];
export const APP_ENV = process.env['APP_ENV'];
export const V2_URL = process.env['V2_URL'];
